module.exports = __webpack_public_path__ + "img/Image6.1af648a4.jpg";